module.exports = __webpack_public_path__ + "static/media/sendmail.f3d47679.svg";